var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Submit Reply ")]),
      _vm.cancellation.replies_enabled
        ? _c(
            "gg-card-text",
            [
              _c("gg-input-label", [_vm._v("Message body")]),
              _c("v-textarea", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: _vm.rules.message,
                    expression: "rules.message"
                  }
                ],
                staticClass: "gg-input",
                attrs: {
                  dense: "",
                  outlined: "",
                  "data-vv-name": "message",
                  "data-vv-as": "Message",
                  "error-messages": _vm.errors.collect("message")
                },
                model: {
                  value: _vm.model.message,
                  callback: function callback($$v) {
                    _vm.$set(_vm.model, "message", $$v)
                  },
                  expression: "model.message"
                }
              }),
              _c(
                "gg-btn",
                {
                  attrs: {
                    color: "primary",
                    tile: "",
                    small: "",
                    loading: _vm.loading,
                    disabled: _vm.loading
                  },
                  on: {
                    click: _vm.submitReply
                  }
                },
                [_vm._v(" Submit reply ")]
              )
            ],
            1
          )
        : _c("v-card-text", [
            _vm._v(" You can no longer reply to this request. ")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }